import { render, staticRenderFns } from "./TabNotificationBubbleNew.vue?vue&type=template&id=410de218&scoped=true"
import script from "./TabNotificationBubbleNew.vue?vue&type=script&lang=ts"
export * from "./TabNotificationBubbleNew.vue?vue&type=script&lang=ts"
import style0 from "./TabNotificationBubbleNew.vue?vue&type=style&index=0&id=410de218&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410de218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('410de218')) {
      api.createRecord('410de218', component.options)
    } else {
      api.reload('410de218', component.options)
    }
    module.hot.accept("./TabNotificationBubbleNew.vue?vue&type=template&id=410de218&scoped=true", function () {
      api.rerender('410de218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabNotificationBubbleNew.vue"
export default component.exports